import React, { ReactElement } from 'react';
import { IDocumentIconProps } from './types';
import { SCSvgPath, SCSvgRoot, SCSvgWrapper } from './styles';

const DocumentIcon = ({ iconState, disabled }: IDocumentIconProps): ReactElement => {
    return (
        <SCSvgWrapper
            data-testid={'document_icon'}
            aria-disabled={disabled ? 'true' : 'false'}
            role="img"
            aria-label="Document icon"
        >
            <SCSvgRoot
                aria-labelledby="Document icon"
                role="group"
                width="100%"
                height="100%"
                viewBox="0 0 25 25"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlSpace="preserve"
            >
                <SCSvgPath
                    animate={iconState}
                    data-testid={iconState ? 'DocumentIconActive' : 'DocumentIconInactive'}
                    disabled={disabled}
                    d="M14.5201 0H6.25C4.52411 0 3.125 1.39911 3.125 3.125V21.875C3.125 23.6009 4.52411 25 6.25 25H18.75C20.4759 25 21.875 23.6009 21.875 21.875V7.35485C21.875 6.94045 21.7104 6.54303 21.4174 6.25L15.625 0.457646C15.332 0.16462 14.9345 0 14.5201 0ZM14.8438 5.46875V2.34375L19.5312 7.03125H16.4062C15.5433 7.03125 14.8438 6.3317 14.8438 5.46875ZM7.03125 14.0625C6.59978 14.0625 6.25 13.7127 6.25 13.2812C6.25 12.8498 6.59978 12.5 7.03125 12.5H17.9688C18.4002 12.5 18.75 12.8498 18.75 13.2812C18.75 13.7127 18.4002 14.0625 17.9688 14.0625H7.03125ZM6.25 16.4062C6.25 15.9748 6.59978 15.625 7.03125 15.625H17.9688C18.4002 15.625 18.75 15.9748 18.75 16.4062C18.75 16.8377 18.4002 17.1875 17.9688 17.1875H7.03125C6.59978 17.1875 6.25 16.8377 6.25 16.4062ZM7.03125 20.3125C6.59978 20.3125 6.25 19.9627 6.25 19.5312C6.25 19.0998 6.59978 18.75 7.03125 18.75H13.2812C13.7127 18.75 14.0625 19.0998 14.0625 19.5312C14.0625 19.9627 13.7127 20.3125 13.2812 20.3125H7.03125Z"
                />
            </SCSvgRoot>
        </SCSvgWrapper>
    );
};

export { DocumentIcon };
